import React from 'react';
import { BookOpenIcon, FileTextIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { HERO_BODY, HERO_EMPHASIS, HERO_HEADLINE, HERO_SUB, MAIN_MOCKUP } from '../data/unstuckContent';
const INDICATORS = [{
  Icon: FileTextIcon,
  label: '100% PDF'
}, {
  Icon: ZapIcon,
  label: 'Access in 5 min'
}, {
  Icon: BookOpenIcon,
  label: 'Beginner to advanced'
}];
export function Hero() {
  return <header className="w-full bg-charcoal-950" data-id="element-105" data-mp="xae7j0m5yila">
      <div className="mx-auto flex max-w-6xl flex-col px-5 pb-8 pt-6 text-center lg:grid lg:grid-cols-[1.05fr_1fr] lg:grid-rows-[auto_auto] lg:items-center lg:gap-x-14 lg:py-14 lg:text-left" data-id="element-106" data-mp="xbpawzbp5obv">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-107" data-mp="nb6n5th0hnoo">
          <p className="text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-108" data-mp="3d1a4l90jrr80">
            Redondoland™
          </p>
          <h1 className="mx-auto mt-3 max-w-xl font-display text-[1.35rem] font-semibold leading-tight text-ivory-50 sm:text-[1.75rem] lg:mx-0 lg:mt-4 lg:text-[2.15rem]" data-id="element-109" data-mp="381nuv9jxgt3y">
            {HERO_HEADLINE}
          </h1>

          {HERO_BODY.map(line => <p key={line} className="mx-auto mt-3 max-w-lg text-[13px] leading-relaxed text-body sm:text-[15px] lg:mx-0" data-id="element-110" data-mp="39acuifmnb6os">
              {line}
            </p>)}

          <p className="mx-auto mt-3 max-w-lg font-display text-[1.1rem] italic leading-snug text-champagne sm:text-2xl lg:mx-0" data-id="element-111" data-mp="30hhq1o505f02">
            {HERO_EMPHASIS}
          </p>
        </div>

        <img src={MAIN_MOCKUP} alt="The complete UNSTUCK system — six volumes and five strategic bonuses" className="mx-auto my-6 w-full max-w-sm object-contain sm:max-w-md lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:my-0 lg:max-w-none" width={1080} height={1080} style={{
        width: "207px",
        height: "201px"
      }} data-id="element-112" data-mp="2qjv4wjx40r7n" />

        <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-113" data-mp="2lla4okhuy7j7">
          <p className="mx-auto max-w-md text-[12.5px] font-medium uppercase tracking-[0.1em] leading-snug text-ivory-200 sm:text-[13px] lg:mx-0 lg:mt-6 lg:max-w-lg" data-id="element-114" data-mp="2lml8ulf7thau">
            {HERO_SUB}
          </p>

          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-muted sm:text-[11px] lg:mt-4 lg:justify-start" data-id="element-115" data-mp="ic873bxiq0w9">
            {INDICATORS.map(({
            Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5" data-id="element-116" data-mp="1azkutpff0er5">
                <Icon className="h-3 w-3 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-117" data-mp="161az9dps3c50" />
                {label}
              </li>)}
          </ul>

          <div className="mt-5 flex justify-center lg:justify-start" data-id="element-118" data-mp="x0l4mdc97rsv">
            <CtaButton size="md" label="I want my UNSTUCK now →" data-id="element-119" data-mp="3lt75kr1phru9" />
          </div>
          <TrustStrip className="mt-3 lg:justify-start" data-id="element-120" data-mp="3hrlp6vpyqvfb" />
        </div>
      </div>
    </header>;
}